import { Navigate, Route, Routes } from 'react-router';
import Header from '../common/shell/header/header.component';
import { withAuth } from '../domains/auth/context/auth-context';
import RouteWithTitle from './route-with-title.component';
import routes from './routes';

const AppRoutes = ({ user }) => (
    <Routes>
        {routes
            .filter(r => user.role >= r.role)
            .map(route => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <>
                            <Header className="app__header" backArrow={route.backArrow} />
                            <div className="app__content">
                                <RouteWithTitle route={route} />
                            </div>
                        </>
                    }
                />
            ))}
        <Route element={<Navigate to="/teams" replace />} />
    </Routes>
);

export default withAuth()(AppRoutes);
